<template>
    <tr :data-id="item.id" :class="classes" :active="props.selected" @click="select()">
        <td class="text-xs-right lotnb">
            {{ item.nb }}
            <p class="primary--text" v-if="item.errata"><a @click="errataDetail()">SRN</a></p>
        </td>
        <td class="text-xs-left py-3">
            <v-icon v-if="item.notes_img || item.notes" @click="notesDetail()" color="primary">announcement</v-icon>
            <code v-if="item.done">{{ item.updated_by }}</code>
            {{ item.title }}
            <p v-if="props.selected" class="expand-btn mt-3"><a @click="expand()">Détail</a></p>
        </td>
        <td class="text-xs-center">
            {{ item.estimate_down | num }}&nbsp;/
            {{ item.estimate_up | num }}
        </td>
        <td class="owner">
            <span @click="ownerDetail()">{{ item.owner.code }}</span>
        </td>
        <td class="text-xs-right reserve">
            <strong>{{ item.reserve_price | num }}</strong>
            <p v-if="flexiReserve !== null">
                <span>flex</span>
                {{ flexiReserve | num }}
            </p>
        </td>
        <td class="text-xs-right bids bids-normal" @click="bidsDetail('normal')">
            <ul>
                <li v-for="bid in item.bidsNormal" :key="bid.id">
                    <span v-if="bid.amount">{{ bid.amount | num }} # {{ bid.auction_number }}</span>
                    <span v-else># {{ bid.auction_number }}</span>
                </li>
            </ul>
        </td>
        <td class="text-xs-right bids bids-tel">
            <ul>
                <li v-for="bid in item.bidsPhone"
                    :key="bid.id"
                    @click="toggleBidCheck(bid)"
                    :class="{ checked: bid.checked }">
                    <span v-if="bid.amount">{{ bid.amount | num }} § {{ bid.auction_number }}</span>
                    <span v-else>§ {{ bid.auction_number }}</span>
                </li>
            </ul>
        </td>
        <td class="saisie">
            <pad-lot-field
                ref="price"
                type="price"
                :label="props.selected ? 'Adjudic' : ''"
                v-model="item.sell_price"
                :item="item"
                :loading="loading"
                @validate="validate" />
        </td>
        <td class="saisie buyer">
            <pad-lot-field
                ref="bidder"
                type="bidder"
                :label="props.selected ? 'Acheteur' : ''"
                v-model="item.auction_number"
                :item="item"
                :loading="loading"
                @validate="validate" />
        </td>
    </tr>
</template>

<script>
import PadLotField from '@/components/PadLotField'

const setDefault = item => JSON.stringify({ a: item.sell_price, b: item.auction_number })

export default {
    name: 'pad-lot-list-table',
    components: { PadLotField },
    props: {
        item: { type: Object },
        props: {}
    },
    data: () => ({
        loading: false,
        popupError: {},
        start: ''
    }),
    computed: {
        classes() {
            const cls = { active: this.props.selected }
            if (this.item.done) {
                if (!this.item.sell_price && !this.item.auction_number) {
                    cls['red lighten-5 pad-lot-list-table-border'] = true
                } else {
                    cls['green lighten-5 pad-lot-list-table-border'] = true
                }
            }
            return cls
        },
        flexiReserve() {
            if (!this.item.flexibility_value) {
                return null
            }
            const r = this.item.reserve_price
            return r - (r * this.item.flexibility_value)
        },
        focusProps() {
            return this.item.focus
        },
        visa() {
            return this.$store.getters['visa/visa']
        }
    },
    watch: {
        focusProps: 'focus'
    },
    mounted() {
        // il faut gérer le null et le 0 pour les champs, si le lot est déjà
        // invendu, sinon ça fait des histoires coté backend
        if (this.item.not_sold) {
            if (!this.item.sell_price) {
                this.item.sell_price = 0
            }
            if (!this.item.auction_number) {
                this.item.auction_number = 0
            }
        }
        this.start = setDefault(this.item)
    },
    methods: {

        ownerDetail() {
            this.$emit('expanded', { item: this.item, props: this.props, tab: 'lot-tab-owner' })
        },

        errataDetail() {
            this.$store.commit('errata/show', { item: this.item })
        },

        bidsDetail(type) {
            this.$emit('expanded', { item: this.item, props: this.props, tab: `lot-tab-bid${type}` })
        },

        notesDetail() {
            this.$emit('expanded', { item: this.item, props: this.props, tab: 'lot-tab-notes' })
        },

        select() {
            if (this.props.selected) {
                return
            }
            this.$emit('selected', { item: this.item, props: this.props })
        },

        focus() {
            this.$refs.price.focus()
        },

        expand() {
            this.$emit('expanded', { item: this.item, props: this.props })
        },

        toggleBidCheck(bid) {
            this.loading = true
            bid.checked = !bid.checked
            return this.$api.put(`/apad/bids/${bid.id}/toggle-check`)
                .catch(err => {
                    bid.checked = !bid.checked
                    throw err
                })
                .finally(() => this.loading = false)
        },

        validate(data) {
            if (this.start === setDefault(this.item)) {
                return
            }
            this.loading = true
            const req = {
                sell_price: this.item.sell_price,
                auction_number: this.item.auction_number,
                visa: this.visa
            }
            if (data.type === 'price' && data.action === 'next') {
                this.$refs.bidder.focus()
            }
            if (data.type === 'bidder') {
                if (data.action === 'prev') {
                    this.$refs.price.focus()
                } else if (data.action === 'next') {
                    this.$emit('bidded', { item: this.item, props: this.props, expanded: this.props.expanded })
                    this.props.expanded = false
                }
            }
            return this.$api.put(`/apad/lots/${this.item.id}`, req)
                .then(res => {
                    this.item.done = !!(this.item.sell_price !== null && this.item.auction_number !== null)
                    // si on est au lot suivant, on focus le lot suivant
                    if (data.type === 'bidder' && data.action === 'next') {
                        this.$emit('done', this.item)
                    }
                    if (this.item.done) {
                        this.item.updated_by = this.visa
                    }

                    this.start = setDefault(req)
                    if (this.item.done && res.data.soldUnderReserve && this.item.popupReserve !== this.item.sell_price) {
                        // pour éviter que la popup viennent 36x
                        this.item.popupReserve = this.item.sell_price
                        // sans le setTimeout, on se retrouve dans une boucle infinie
                        // qui provient de je-ne-sais-où
                        window.setTimeout(() => {
                            this.$store.commit('msg/showPopup', {
                                title: `Lot ${this.item.nb} vendu sous la réserve`,
                                message: `Le lot a été vendu à CHF <strong>${this.item.sell_price}</strong> alors que sa réserve est de CHF <strong>${this.item.reserve_price}</strong>.`
                            })
                        }, 500)
                    }
                })
                .catch(err => {
                    if (!this.popupError[this.item.id]) {
                        this.popupError[this.item.id] = {}
                    }
                    const values = `${this.item.sell_price} ${this.item.auction_number}`
                    if (this.popupError[this.item.id] === values) {
                        return
                    }
                    this.popupError[this.item.id] = values
                    // sans le setTimeout, on se retrouve dans une boucle infinie
                    // qui provient de je-ne-sais-où
                    window.setTimeout(() => {
                        const res = (err.response && err.response.data) || {}
                        const title = (res.error && res.error.title) || 'Erreur de saisie'
                        const msg = (res.error && res.error.message) || (err && err.message)
                        this.$store.commit('msg/showPopup', {
                            title: title,
                            message: msg
                        })
                    }, 500)
                })
                .finally(() => this.loading = false)
        }
    }
}
</script>

<style lang="stylus">
$fontselected = 26px;
$fontnormal = 18px;

.pad-lot-table
    table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child)
        padding-left: 14px;
        padding-right: 14px;

    .v-table tbody td
        font-size: $fontnormal;

    .active td
        padding-top: 30px !important;
        padding-bottom: 30px !important;
        font-size: $fontselected !important;

        &.owner
            font-size: $fontnormal !important;
            strong
                font-size: $fontselected;

        li.detail
            margin-top: 30px;
            font-size: $fontnormal;

    .expand-btn
        font-size: $fontnormal;

    .v-input__slot
        padding-left: 0 !important;
        padding-right: 0 !important;

        input
            text-align: right;

    .lotnb
        white-space: nowrap;

        p
            font-weight: bold;

    .reserve p
        color: #777;
        font-size: 80%;

        span
            display: block;
            border-top: 1px solid #ccc;
            font-size: 70%;
            line-height: 0.5;
            padding-top: 10px;

    .saisie
        min-width: 150px;

        &.buyer
            min-width: 120px;

    .bids
        min-width: 180px;

        &.bids-normal
            color: $color-primary;

        &.bids-tel
            color: $color-secondary;

    ul
        list-style: none;
        margin: 0;

        li
            white-space: nowrap;

        .checked
            text-decoration: line-through;

    .pad-lot-list-table-border
        border-color: rgba(0, 0, 0, 0.2) !important;

</style>
